import { apiFetch } from './api';

/**
 * Listes (colonnes) du tableau Trello.
 *
 * L'appel passe par le backend : la clé et le jeton Trello vivent dans ses
 * variables d'environnement, et n'ont rien à faire dans le bundle du
 * navigateur, que n'importe quel visiteur peut lire.
 */
export function getListesTrello(tableau) {
  const query = tableau ? `?tableau=${encodeURIComponent(tableau)}` : '';
  return apiFetch(`/trello/listes${query}`);
}

/** Cartes d'une liste Trello : nom, description, échéance, étiquettes, lien. */
export function getCartesTrello(idListe) {
  return apiFetch(`/trello/listes/${idListe}/cartes`);
}
